import {FormControl, MenuItem, Select as RawSelect, styled} from '@mui/material'
import {Colors} from 'appearance'
import {i18n} from 'common'
import {useEffect, useState} from 'react'
import moment from 'moment'
import PeriodSelectDialog from './PeriodSelect/PeriodSelectDialog'
import usePeriod, {periods} from 'logic/Dashboard/usePeriod'
import {useDeviceDetect} from 'services/hooks'

const PeriodSelect = ({onSelectPeriod, ...p}) => {
    const {isMobile} = useDeviceDetect()
    const [openCustomPeriod, setOpenCustomPeriod] = useState(false)

    const {from, to, label, setPeriod} = usePeriod()

    useEffect(() => {
        if (from && to) {
            onSelectPeriod({from, to, label})
        }
    }, [from, to, label, onSelectPeriod])

    const toggleOpenCustomPeriod = () => {
        setOpenCustomPeriod(!openCustomPeriod)
    }

    const onSelect = (event) => {
        if (event.target.value !== 'custom') {
            setPeriod(event.target.value)
        }
    }

    const format = (date) => moment(date, 'YYYY-MM-DD').format('D MMMM, YYYY')
    const renderValue = (value) => {
        if (value === 'custom') {
            return i18n.t('dashboard.period', {
                from: format(from),
                to: format(to),
            })
        }
        return i18n.t(`dashboard.periods.${value}`)
    }

    const periodsKeys = Object.keys(periods || {})

    return (
        <Container isMobile={isMobile} {...p}>
            <FormControl
                variant="outlined"
                sx={{width: isMobile ? '100%' : 280}}
                {...p}>
                <StyledSelect
                    MenuProps={{
                        PaperProps: {
                            style: {minWidth: 280},
                        },
                    }}
                    defaultValue={periodsKeys[0]}
                    renderValue={renderValue}
                    onChange={onSelect}>
                    {periodsKeys.map((option) => (
                        <MenuItem
                            key={option}
                            selected
                            dir="rtl"
                            value={option}>
                            {i18n.t(`dashboard.periods.${option}`)}
                        </MenuItem>
                    ))}
                    <MenuItem
                        key="custom"
                        selected
                        dir="rtl"
                        value="custom"
                        onClick={toggleOpenCustomPeriod}>
                        {i18n.t('dashboard.periods.custom')}
                    </MenuItem>
                </StyledSelect>
            </FormControl>
            <PeriodSelectDialog
                open={openCustomPeriod}
                onSelectPeriod={onSelectPeriod}
                onCancel={toggleOpenCustomPeriod}
            />
        </Container>
    )
}

export default PeriodSelect

const Container = styled('div')`
    width: ${({isMobile}) => (isMobile ? '100%' : 'auto')}; ;
`

const StyledSelect = styled(RawSelect)`
    height: 35px;
    background: ${Colors.APP_WHITE};
    border-radius: 8px;
    border-color: '#D8D8D8';
    display: flex;
    padding-inline: 14px;
    & .MuiSelect-select {
        padding-right: 0 !important;
    }
    & svg {
        position: unset;
    }
    min-width: 100%;
`
